"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _tickersActions = require("../../redux/actions/tickersActions");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _get = _interopRequireDefault(require("lodash/get"));
var _LightWeightChartContainer = require("../LightWeightCharts/LightWeightChartContainer");
var _selectors = require("../../redux/futures/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var isFuturesActive = (0, _selectors.isFuturesActiveSelector)(state);
  return {
    chartType: 'line',
    selectedInstrument: selectedInstrument,
    priceData: isFuturesActive ? (0, _selectors.getFuturesTickersList)(state) : (0, _get["default"])(state, 'tickers.tickers', []),
    selectedInterval: state.tickers.interval,
    selectedInstrumentId: selectedInstrument.InstrumentId,
    hideVolume: true,
    hideIntervalButtons: true
  };
};
var mapDispatchToProps = {
  changeTickersInterval: _tickersActions.changeTickersInterval
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LightWeightChartContainer.LightWeightChart);